export default {"src":"__ASTRO_ASSET_IMAGE__CN9H8mXB__","width":825,"height":528,"format":"png"}